import {
    ADD_SEARCHED_USER, CHANGE_LANG,
    CHANGE_MENU_ITEM, CHANGE_MENU_SUBITEM, CHANGE_SEARCH_ITEMS, CHANGE_SEARCH_WORD, CLEAR_SEARCH_ITEMS, GET_TABLE_DATA,
    GET_USER_DATA, GET_GROUP_DATA, GIFT_POPUP,
    HIDE_404,
    HIDE_LOADER,
    MAIN_REQUEST, MOBILE_LANG, MOBILE_POPUP, QAA_CLICK,
    SHOW_404,
    SHOW_LOADER, SUMMARY, SUMMARY_POPUP, SUMMARY_REQUEST,
    TABLE_REQUEST, USER_POPUP,
    SET_GAME,
    SET_SPIN_READY, SET_SPIN_NOT_READY, SET_CODE,
    CODE_POPUP,
    RECEIVED_GIFT_POPUP, CLEAN_RECEIVED_GIFT,
    WINNERS_POPUP,
    GIFTSLIST_POPUP,
    RECIVED_GIFT,
    ADD_WHEEL_WINNERS, ADD_SHOP_WINNERS,
    WHEEL_PAGINATION, SHOP_PAGINATION,
    ALL_WHEEL_WINNERS, ALL_SHOP_WINNERS,
    WHEEL_ANIMATION,
    GET_ERROR_ALERT, CLOSE_ERROR_ALERT, WHEEL_DEG,
    SHOW_SEARCH_LOADER, HIDE_SEARCH_LOADER,
    SHOW_CODE_LOADER, HIDE_CODE_LOADER,
    SET_GROUP,
    LOGIN_POPUP, SET_LOGIN,
    SHOW_LOGIN_LOADER, HIDE_LOGIN_LOADER,
    SET_POINTS, SUBSTRACT_POINTS,
    SET_SELECTED_GIFT,
    SHOP_WINNERS_POPUP,
    CONFIRM_SPIN_POPUP,
    CONFIRM_GIFT_POPUP,
    SET_REMAIN_POINTS,
    CONFIRM_POPUP_LOADING,
    RECIVED_SHOP_GIFT,
    RECEIVED_SHOP_GIFT_POPUP,
    CLEAN_RECEIVED_SHOP_GIFT,
    SET_SHOP_GIFTS,
} from "./types";
import Cookies from 'js-cookie';
import {api, apiNoAlert} from '../middleware/'

export function showLoader() {
    return { type: SHOW_LOADER }
}

export function hideLoader() {
    return { type: HIDE_LOADER }
}

export function show404() {
    document.title = '404'
    return { type: SHOW_404 }
}

export function hide404() {
    return { type: HIDE_404 }
}

export function setGroup(group) {
    return { type: SET_GROUP, payload: group }
}

export function mainRequest() {
    return { type: MAIN_REQUEST }
}

export function tableRequest() {
    return { type: TABLE_REQUEST }
}

export function summaryRequest() {
    return { type: SUMMARY_REQUEST }
}
export function setSelectedGift(id) {
    return { type: SET_SELECTED_GIFT, payload: id }
}

export function getUserData(name) {
    return async dispatch => {
        dispatch(showLoader())
        try {
            dispatch(mainRequest())
            api.get('api/table/' + name)
                .then((res) => {
                    const json = res.data;
                    if (json !== 'Профиль не найден') {
                        document.title = 'Таблица лидеров ' + name
                        const payload = {
                            id: (typeof json.id !== 'undefined') ? json.id : null,
                            name: (typeof json.name !== 'undefined') ? json.name : null,
                            image: (typeof json.image !== 'undefined') ? json.image : null,
                            isActive: (typeof json.isActive !== 'undefined') ? json.isActive : null,
                            isSupportEnabled: (typeof json.isSupportEnabled !== 'undefined') ? json.isSupportEnabled : null,
                            conditions: (typeof json.conditions !== 'undefined') ? json.conditions : null,
                            showLink: (typeof json.showLink !== 'undefined') ? json.showLink : null,
                            isPartnerEnabled: (typeof json.isPartnerEnabled !== 'undefined') ? json.isPartnerEnabled : null,
                            showConditionsFirst: (typeof json.showConditionsFirst !== 'undefined') ? json.showConditionsFirst : null,
                            link: (typeof json.link !== 'undefined') ? json.link : null,
                            hasActiveGame: (typeof json.hasActiveGame !== 'undefined') ? json.hasActiveGame : null,
                            showLinkInGames: json.showLinkInGames ?? null
                        }                           
                        const gameState = {
                            settings: null,
                            gifts: [],
                            winners: [],
                        }
                        let gameWheel = gameState;
                        let gameShop = gameState;
                        if (typeof json.hasActiveGame !== 'undefined' && payload.hasActiveGame && json.game && Array.isArray(json.game) && json.game.length > 0) {
                            //dispatch(setGames(json.game))
                            for (let i = 0; i < json.game.length; i++) {
                                if (json.game[i].settings?.type === 1) {
                                    gameWheel = {
                                        settings: json.game[i]?.settings ?? null,
                                        gifts: json.game[i]?.gifts ?? [],
                                        winners: json.game[i]?.winners ?? [],
                                    }
                                } else if (json.game[i].settings?.type === 2) {
                                    gameShop = {
                                        settings: json.game[i]?.settings ?? null,
                                        gifts: json.game[i]?.gifts ?? [],
                                        winners: json.game[i]?.winners ?? [],
                                    }
                                }
                            }
                            dispatch({ type: SET_GAME, gameWheel, gameShop })
                        }
                        if (typeof json.hasActiveGame !== 'undefined' && payload.hasActiveGame && json.game && Array.isArray(json.game) && json.game.length > 0 && ((gameWheel.settings && gameWheel.settings.status === 'active') || (gameShop.settings && gameShop.settings.status === 'active'))) {
                            if(gameWheel.settings && gameWheel.settings.status !== 'archived'){
                                dispatch({ type: CHANGE_MENU_SUBITEM, payload: 'games' })
                            } else if (gameShop.settings && gameShop.settings.status !== 'archived'){
                                dispatch({ type: CHANGE_MENU_SUBITEM, payload: 'shop' })
                            }
                        } else if (payload.showConditionsFirst === 1 || (payload.conditions != null && payload.conditions.length > 0)) {
                            dispatch({ type: CHANGE_MENU_SUBITEM, payload: 'conditionals' })
                        }
                        dispatch({ type: GET_USER_DATA, payload: payload })
                    } else {
                        dispatch(show404())
                    }
                    dispatch(hideLoader())
                })
                .catch(err => {
                    dispatch(hideLoader())
                    dispatch(show404())
                })
        } catch (e) {
            dispatch(mainRequest())
            dispatch(hideLoader())
            dispatch(show404())
        }
    }

}

export function getGroupData(groupId) {
    return async dispatch => {
        dispatch(showLoader())
        try {
            dispatch(mainRequest())
            api.get('api/table/group/' + groupId)
                .then((res) => {
                    const json = res.data;
                    if (json !== 'Профиль не найден') {
                        document.title = 'Таблица лидеров ';
                        const payload = {
                            id: json.id ?? null,
                            group: json.group ?? [],
                            isSupportEnabled: json.isSupportEnabled ?? null,
                            conditions: json.conditions ?? null,
                            showLink: json.showLink ?? null,
                            isPartnerEnabled: json.isPartnerEnabled ?? null,
                            showConditionsFirst: json.showConditionsFirst ?? null,
                            link: json.link ?? null,
                            hasActiveGame: json.hasActiveGame ?? null,
                            showLinkInGames: json.showLinkInGames ?? null
                        }
                        const gameState = {
                            settings: null,
                            gifts: [],
                            winners: [],
                        }
                        let gameWheel = gameState;
                        let gameShop = gameState;
                        if (typeof json.hasActiveGame !== 'undefined' && payload.hasActiveGame && json.game && Array.isArray(json.game) && json.game.length > 0) {
                            //dispatch(setGames(json.game))
                            for (let i = 0; i < json.game.length; i++) {
                                if (json.game[i].settings?.type === 1) {
                                    gameWheel = {
                                        settings: json.game[i]?.settings ?? null,
                                        gifts: json.game[i]?.gifts ?? [],
                                        winners: json.game[i]?.winners ?? [],
                                    }
                                } else if (json.game[i].settings?.type === 2) {
                                    gameShop = {
                                        settings: json.game[i]?.settings ?? null,
                                        gifts: json.game[i]?.gifts ?? [],
                                        winners: json.game[i]?.winners ?? [],
                                    }
                                }
                            }
                            dispatch({ type: SET_GAME, gameWheel, gameShop })
                        }
                        if (typeof json.hasActiveGame !== 'undefined' && payload.hasActiveGame && json.game && Array.isArray(json.game) && json.game.length > 0) {
                            if(gameWheel.settings && gameWheel.settings.status === 'active'){
                                dispatch({ type: CHANGE_MENU_SUBITEM, payload: 'games' })
                            } else if (gameShop.settings && gameShop.settings.status === 'active'){
                                dispatch({ type: CHANGE_MENU_SUBITEM, payload: 'shop' })
                            }
                        } else if (payload.showConditionsFirst === 1 || (payload.conditions != null && payload.conditions.length > 0)) {
                            dispatch({ type: CHANGE_MENU_SUBITEM, payload: 'conditionals' })
                        }
                        dispatch({ type: GET_GROUP_DATA, payload: payload })
                    } else {
                        dispatch(show404())
                    }
                    dispatch(hideLoader())
                })
                .catch(err => {
                    dispatch(hideLoader())
                    dispatch(show404())
                })
        } catch (e) {
            dispatch(mainRequest())
            dispatch(hideLoader())
            dispatch(show404())
        }
    }
}

export function getTopTable(id) {
    return async dispatch => {
        try {
            dispatch(tableRequest())
            api.get('api/subscribers/' + id)
                .then((res) => {
                    dispatch({ type: GET_TABLE_DATA, payload: res.data })
                })
        } catch (e) {
            dispatch({ type: GET_TABLE_DATA, payload: null })
        }
    }

}

export function getSummary(id) {
    return async dispatch => {
        try {
            dispatch(summaryRequest())
            api.get('api/profiles/' + id + '/stats')
                .then((res) => {
                    dispatch({ type: SUMMARY, payload: res.data })
                })
        } catch (e) {
            dispatch({ type: SUMMARY, payload: null })
        }
    }
}

export function changeMenuItem(menuItem) {
    return { type: CHANGE_MENU_ITEM, payload: menuItem }
}

export function changeMenuSubitem(menuSubItem) {
    return { type: CHANGE_MENU_SUBITEM, payload: menuSubItem }
}

export function change_search_word(value) {
    return { type: CHANGE_SEARCH_WORD, payload: value }
}
export function showSearchLoader() {
    return { type: SHOW_SEARCH_LOADER }
}

export function hideSearchLoader() {
    return { type: HIDE_SEARCH_LOADER }
}

export function searchKeyPress(value, id) {

    if (value.length >= 3 && id > 0) {
        return async dispatch => {
            //dispatch({type: CHANGE_SEARCH_WORD, payload: value})
            try {
                api.get('api/subscribers/search/' + id + '?subscriber=' + value)
                    .then((res) => {
                        const json = res.data;
                        if (json.length > 0) {
                            dispatch({ type: CHANGE_SEARCH_ITEMS, payload: { searchItems: json } })
                        } else {
                            dispatch({ type: CHANGE_SEARCH_ITEMS, payload: { searchItems: [] } })
                        }
                    })
            } catch (e) {
                dispatch({ type: CHANGE_SEARCH_ITEMS, payload: { searchItems: [] } })
            }
        }
    }
    return { type: CHANGE_SEARCH_ITEMS, payload: { searchItems: [] } }
}

export function clearSearchResult() {
    return { type: CLEAR_SEARCH_ITEMS, payload: { searchItems: [] } }
}

export function searchItemClick(name, id, errorText) {
    return async dispatch => {
        try {
            dispatch(showSearchLoader())
            dispatch(change_search_word(name))
            api.get('api/subscribers/' + id + '/' + name)
                .then((res) => {
                    const json = res.data;
                    if (Array.isArray(json) && (json.length === 0)) {
                        throw new Error("")
                    } else {
                        const payload = {
                            id: (typeof json.id !== 'undefined') ? json.id : null,
                            name: (typeof json.name !== 'undefined') ? json.name : null,
                            total: (typeof json.total !== 'undefined') ? json.total : null,
                            likes: (typeof json.likes !== 'undefined') ? json.likes : null,
                            comments: (typeof json.comments !== 'undefined') ? json.comments : null,
                            messages: (typeof json.messages !== 'undefined') ? json.messages : null,
                        }
                        dispatch({ type: ADD_SEARCHED_USER, payload: payload })
                    }
                })
                .catch(e => {
                    dispatch(getErrorAlert(errorText))
                    dispatch({ type: ADD_SEARCHED_USER, payload: {} })
                }).finally(() => {
                    dispatch(hideSearchLoader())
                })
        } catch (e) {
            dispatch({ type: ADD_SEARCHED_USER, payload: {} })
        }

    }
}

export function qaaClick(item) {

    return async dispatch => {
        try {
            dispatch({ type: QAA_CLICK, payload: item })
        } catch (e) {
            dispatch({ type: QAA_CLICK, payload: null })
        }
    }
}

export function qaaClose() {
    return async dispatch => {
        try {
            dispatch({ type: QAA_CLICK, payload: null })
        } catch (e) {
            dispatch({ type: QAA_CLICK, payload: null })
        }
    }

}

export function changeLang(currentLangName, currentLang) {
    Cookies.set('locale', currentLangName.toString().toLowerCase(), { expires: (365 * 5) })
    return { type: CHANGE_LANG, payload: { currentLangName: currentLangName, currentLang: currentLang } }
}

export function getGiftPopup(giftPopup) {
    if (giftPopup === null) {
        document.body.className = document.body.className.replace("noscroll", "");
    } else {
        document.body.classList.add("noscroll");
    }

    return { type: GIFT_POPUP, payload: giftPopup }
}

export function getUserPopup(id, s_id, name) {
    return async dispatch => {
        try {
            document.body.classList.add("noscroll");
            dispatch({ type: USER_POPUP, payload: { userPopup: null, userPopupName: name, userPopupLoading: true } })
            api.get('api/points/' + id + '/' + s_id)
                .then((res) => {
                    const json = res.data;
                    if (json.length > 0) {
                        dispatch({
                            type: USER_POPUP,
                            payload: { userPopup: json, userPopupName: name, userPopupLoading: false }
                        })
                    } else {
                        dispatch({
                            type: USER_POPUP,
                            payload: { userPopup: null, userPopupName: name, userPopupLoading: false }
                        })
                    }
                })
                .catch(e => {
                    console.log(e)
                    document.body.className = document.body.className.replace("noscroll", "");
                    dispatch({ type: USER_POPUP, payload: { userPopup: null, userPopupName: null, userPopupLoading: false } })
                })
        } catch (e) {
            console.log(e)
            document.body.className = document.body.className.replace("noscroll", "");
            dispatch({ type: USER_POPUP, payload: { userPopup: null, userPopupName: null, userPopupLoading: false } })
        }
    }
}

export function getSummaryPopup() {
    return async dispatch => {
        try {
            document.body.classList.add("noscroll");
            dispatch({ type: SUMMARY_POPUP, payload: true })
        } catch (e) {
            document.body.className = document.body.className.replace("noscroll", "");
            dispatch({ type: SUMMARY_POPUP, payload: false })
        }
    }

}

export function closeSummaryPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: SUMMARY_POPUP, payload: false }
}

export function closeUserPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: USER_POPUP, payload: { userPopup: null, userPopupName: null, userPopupLoading: false } }
}

export function getMobilePopup() {
    document.body.classList.add("noscroll");
    return { type: MOBILE_POPUP, payload: true }
}

export function closeMobilePopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: MOBILE_POPUP, payload: false }
}

export function mobileLangActive(val) {
    return { type: MOBILE_LANG, payload: !val }
}

/*export function setGames(game) {
    return async dispatch => {
        try {
            const gameState = {
                settings: null,
                gifts: [],
                winners: [],
            }
            let gameWheel = gameState;
            let gameShop = gameState;
            for (let i = 0; i < game.length; i++) {
                if (game[i].settings?.type === 1) {
                    gameWheel = {
                        settings: game[i]?.settings ?? null,
                        gifts: game[i]?.gifts ?? [],
                        winners: game[i]?.winners ?? [],
                    }
                } else if (game[i].settings?.type === 2) {
                    gameShop = {
                        settings: game[i]?.settings ?? null,
                        gifts: game[i]?.gifts ?? [],
                        winners: game[i]?.winners ?? [],
                    }
                }
            }
            dispatch({ type: SET_GAME, gameWheel, gameShop })
        } catch (e) {

        }
    }
}*/

export function setSpinReady() {
    return { type: SET_SPIN_READY }
}

export function setSpinNotReady() {
    return { type: SET_SPIN_NOT_READY }
}

export function setCode(payload) {
    return { type: SET_CODE, payload: payload }
}

export function setLogin(login, username) {
    return { type: SET_LOGIN, login, username }
}

export function showLoginLoader() {
    return { type: SHOW_LOGIN_LOADER }
}

export function hideLoginLoader() {
    return { type: HIDE_LOGIN_LOADER }
}

export function clearCode() {
    return { type: SET_CODE, payload: '' }
}

export function getCodePopup() {
    document.body.classList.add("noscroll");
    return { type: CODE_POPUP, payload: true }
}

export function closeCodePopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: CODE_POPUP, payload: false }
}

export function startWheelAnimation() {
    return { type: WHEEL_ANIMATION, payload: true }
}

export function stopWheelAnimation() {
    return { type: WHEEL_ANIMATION, payload: false }
}

export function wheelDegChange(deg) {
    return { type: WHEEL_DEG, payload: deg }
}
export function showCodeLoader() {
    return { type: SHOW_CODE_LOADER }
}

export function hideCodeLoader() {
    return { type: HIDE_CODE_LOADER }
}
export function checkCode(id, code) {
    return async dispatch => {
        dispatch(setCode(code));
        dispatch(showCodeLoader())
        api.get('api/table/games/' + id + '/code?code=' + code)
            .then((res) => {
                const json = res.data
                if (json.shouldSpin === true) {
                    dispatch(closeCodePopup())
                    dispatch(setSpinReady())
                    dispatch(hideCodeLoader())
                } else if (json.shouldSpin === false) {
                    const payload = {
                        id: json.gift?.id ?? null,
                        giftId: json.gift?.giftId ?? null,
                        name: json.gift?.name ?? null,
                        image: json.gift?.image ?? null,
                        subscriber: json.gift?.subscriber ?? null,
                        createdAt: json.gift?.createdAt ?? null,
                        points: json.gift?.points ?? null,
                        type: json.gift?.type ?? null,
                    }
                    dispatch({ type: RECIVED_GIFT, payload: payload })
                    dispatch(closeCodePopup())
                    dispatch(clearCode())
                    dispatch(getReceivedGiftPopup())
                    dispatch(hideCodeLoader())
                }
            })
            .catch(e => {
                dispatch(hideCodeLoader())
                dispatch(setSpinNotReady())
            })
    }
}
//TODO: исправить
export function checkToken(id, token, alert = true) {
    return async (dispatch, getState) => {
        console.log(alert)
        dispatch(showLoginLoader())
        console.log(apiNoAlert.interceptors.response)
        const reqApi = alert ? api : apiNoAlert
        reqApi.get('api/subscribers/' + id + '/info?token=' + token)
            .then((res) => {
                const json = res.data;
                const name = getState().user.name;
                localStorage.setItem('token_' + name, token)
                dispatch(setLogin(true, json.name ?? ''))
                dispatch(setPoints(json.points ?? null))
                dispatch(closeLoginPopup())
                dispatch(hideLoginLoader())
            })
            .catch(e => {
                console.log(e)
                dispatch(hideLoginLoader())
                dispatch(setLogin(false, ''))
            })
    }
}
export function logout() {
    return async (dispatch, getState) => {
        const name = getState().user.name;
        localStorage.removeItem('token_' + name)
        dispatch(setLogin(false, ''));
        dispatch(setPoints(null))
    }
}
export function getReceivedGiftPopup() {
    document.body.classList.add("noscroll");
    return { type: RECEIVED_GIFT_POPUP, payload: true }
}

export function closeReceivedGiftPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return async dispatch => {
        dispatch({ type: RECEIVED_GIFT_POPUP, payload: false })
        dispatch({ type: CLEAN_RECEIVED_GIFT })
    }
}

export function getReceivedShopGiftPopup() {
    document.body.classList.add("noscroll");
    return { type: RECEIVED_SHOP_GIFT_POPUP, payload: true }
}

export function closeReceivedShopGiftPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return async dispatch => {
        dispatch({ type: RECEIVED_SHOP_GIFT_POPUP, payload: false })
        dispatch({ type: CLEAN_RECEIVED_SHOP_GIFT })
    }
}

export function getWinnersPopup() {
    document.body.classList.add("noscroll");
    return { type: WINNERS_POPUP, payload: true }
}

export function closeWinnersPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: WINNERS_POPUP, payload: false }
}
export function openShopWinnersPopup() {
    document.body.classList.add("noscroll");
    return { type: SHOP_WINNERS_POPUP, payload: true }
}

export function closeShopWinnersPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: SHOP_WINNERS_POPUP, payload: false }
}
export function getGiftsListPopup() {
    document.body.classList.add("noscroll");
    return { type: GIFTSLIST_POPUP, payload: true }
}

export function closeGiftsListPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: GIFTSLIST_POPUP, payload: false }
}
export function openLoginPopup() {
    document.body.classList.add("noscroll");
    return { type: LOGIN_POPUP, payload: true }
}

export function closeLoginPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: LOGIN_POPUP, payload: false }
}
export function getGiftData(id, code) {
    return async dispatch => {
        dispatch(startWheelAnimation())
        api.post('api/table/games/' + id + '/code', {
            code: code
        }).then((res) => {
            const json = res.data
            const payload = {
                id: json.id ?? null,
                giftId: json.giftId ?? null,
                name: json.name ?? null,
                image: json.image ?? null,
                subscriber: json.subscriber ?? null,
                createdAt: json.createdAt ?? null,
                points: json.points ?? null,
                type: json.type ?? null,
            }
            dispatch({ type: RECIVED_GIFT, payload: payload })
            dispatch(clearCode())
        }).catch(e => {
            console.log("Server error")
            dispatch(setSpinNotReady())
            dispatch(stopWheelAnimation())
        })
    }
}
export function setRemainPoints(points) {
    return { type: SET_REMAIN_POINTS, payload: points }
}
export function getGiftDataByToken(id, price) {
    return async (dispatch, getState) => {
        const name = getState().user.name;
        const token = localStorage.getItem('token_' + name)
        dispatch({ type: CONFIRM_POPUP_LOADING, payload: true })
        api.post('api/table/games/' + id + '/token?token=' + token)
            .then((res) => {
                dispatch(startWheelAnimation())
                dispatch(closeConfirmSpinPopup())
                const json = res.data;
                const payload = {
                    id: json.id ?? null,
                    giftId: json.giftId ?? null,
                    name: json.name ?? null,
                    image: json.image ?? null,
                    subscriber: json.subscriber ?? null,
                    createdAt: json.createdAt ?? null,
                    points: json.points ?? null,
                    type: json.type ?? null,
                }

                dispatch({ type: RECIVED_GIFT, payload: payload })
                dispatch({ type: SUBSTRACT_POINTS, payload: price })
            }).catch(e => {
                console.log("Server error")
                dispatch(setSpinNotReady())
                dispatch(stopWheelAnimation())
                if (!e.response.data) return;
                const json = e.response.data;
                if (json && !json.enoughPoints && json.remainPoints) {
                    dispatch(setRemainPoints(json.remainPoints))
                }

            }).finally(() => {
                dispatch({ type: CONFIRM_POPUP_LOADING, payload: false })
            })
    }
}
export function addWinners(id, winners, pagination, game = 'wheel') {
    return async dispatch => {

        try {
            const type = {
                add: (game === 'wheel') ? ADD_WHEEL_WINNERS : ADD_SHOP_WINNERS,
                pagination: (game === 'wheel') ? WHEEL_PAGINATION : SHOP_PAGINATION,
                all: (game === 'wheel') ? ALL_WHEEL_WINNERS : ALL_SHOP_WINNERS
            }
            if (Array.isArray(winners) && typeof pagination !== 'undefined' && typeof pagination.total !== 'undefined' && typeof pagination.currentPage !== 'undefined' && typeof pagination.perPage !== 'undefined') {
                if (typeof pagination.total === 'number' && pagination.total <= winners.length) {
                    dispatch({ type: type.all, payload: true })
                } else {
                    if (pagination.total === null || pagination.perPage === null || pagination.currentPage === null) {
                        api.get('api/table/games/' + id + '/winners?page=1')
                            .then((res) => {
                                const jsonPagination = res.data;
                                pagination = {
                                    total: (typeof jsonPagination.pagination.total !== 'undefined') ? jsonPagination.pagination.total : null,
                                    count: (typeof jsonPagination.pagination.count !== 'undefined') ? jsonPagination.pagination.count : null,
                                    perPage: (typeof jsonPagination.pagination.perPage !== 'undefined') ? jsonPagination.pagination.perPage : null,
                                    lastPage: (typeof jsonPagination.pagination.lastPage !== 'undefined') ? jsonPagination.pagination.lastPage : null,
                                    nextPageUrl: null,
                                    currentPage: null
                                }
                                if (pagination.perPage !== null) {
                                    pagination.currentPage = Math.floor(winners.length / pagination.perPage);
                                }
                            })
                    }
                    let link = ''
                    if (typeof pagination.nextPageUrl === 'string' && pagination.nextPageUrl.length > 0) {
                        link = pagination.nextPageUrl;
                    } else {
                        let nextPage = 2;
                        if (typeof pagination.total === 'number' && pagination.total > winners.length) {
                            nextPage = pagination.currentPage + 1;
                        }
                        link = process.env.REACT_APP_HOST + '/api/table/games/' + id + '/winners?page=' + nextPage
                    }
                    api.get(link)
                        .then((res) => {
                            const json = res.data;
                            const payload = json.data ?? [];
                            if (typeof json.pagination !== 'undefined') {
                                const paginationPayload = {
                                    total: json.pagination?.total ?? null,
                                    count: json.pagination?.count ?? null,
                                    perPage: json.pagination?.perPage ?? null,
                                    currentPage: json.pagination?.currentPage ?? null,
                                    lastPage: json.pagination?.lastPage ?? null,
                                    nextPageUrl: json.pagination?.nextPageUrl ?? null,
                                }
                                dispatch({ type: type.pagination, payload: paginationPayload })
                                if (typeof pagination.currentPage === 'number' && typeof pagination.perPage === 'number' && pagination.currentPage * pagination.perPage < winners.length) {
                                    let slice = winners.length - (pagination.currentPage * pagination.perPage)
                                    dispatch({ type: type.add, payload: payload, winners: winners.slice(-slice) })
                                } else {
                                    dispatch({ type: type.add, payload: payload, winners: winners })
                                }
                            }
                        })
                }
            }
        } catch (e) {
            console.log(e)
        }
    }
}

export function completeAnimation() {
    return async (dispatch, getState) => {
        dispatch(stopWheelAnimation())
        dispatch(getReceivedGiftPopup())
        dispatch(setSpinNotReady())
        const gift = getState().game.receivedGift
        if (gift.type === 'points' && gift.points) {
            const points = gift.points ?? 0
            dispatch({ type: SUBSTRACT_POINTS, payload: (- points) })
        }
    }
}

export function getErrorAlert(payload) {
    return async dispatch => {
        dispatch({ type: GET_ERROR_ALERT, payload: payload })
        setTimeout(() => {
            dispatch({ type: CLOSE_ERROR_ALERT })
        }, "6000");

    }
}
export function setPoints(payload) {
    return { type: SET_POINTS, payload }
}
export function openGiftPopup() {
    document.body.classList.add("noscroll");
    return { type: GIFT_POPUP, payload: true }
}

export function closeGIftPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: GIFT_POPUP, payload: false }
}
export function openConfirmSpinPopup() {
    document.body.classList.add("noscroll");
    return { type: CONFIRM_SPIN_POPUP, payload: true }
}

export function closeConfirmSpinPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: CONFIRM_SPIN_POPUP, payload: false }
}
export function openConfirmGiftPopup() {
    document.body.classList.add("noscroll");
    return { type: CONFIRM_GIFT_POPUP, payload: true }
}

export function closeConfirmGiftPopup() {
    document.body.className = document.body.className.replace("noscroll", "");
    return { type: CONFIRM_GIFT_POPUP, payload: false }
}
export function buyGift(gameId, giftId) {
    return async (dispatch, getState) => {
        const name = getState().user.name;
        const gifts = getState().game.gameShop.gifts;
        dispatch({ type: CONFIRM_POPUP_LOADING, payload: true })
        api.post(`api/table/games/${gameId}/gifts/${giftId}/buy?token=${localStorage.getItem('token_' + name)}`
        ).then((res) => {
            const json = res.data;
            const payload = {
                id: json.id ?? null,
                giftId: json.giftId ?? null,
                name: json.name ?? null,
                image: json.image ?? null,
                subscriber: json.subscriber ?? null,
                createdAt: json.createdAt ?? null,
                points: json.points ?? null,
                type: json.type ?? null,
                game: 'shop'
            }
            const price = json.price ?? 0;
            dispatch({ type: SUBSTRACT_POINTS, payload: price })
            dispatch(closeConfirmGiftPopup())
            dispatch({ type: RECIVED_SHOP_GIFT, payload: payload })
            dispatch(getReceivedShopGiftPopup())
            let newGifts =[]
            for (let i = 0; i < gifts.length; i++) {
                const element = gifts[i];
                if(element.id === giftId){
                    element.takenQuantity ++;
                    element.leftQuantity --;
                }
                newGifts.push(element);
            }
            dispatch({type: SET_SHOP_GIFTS, payload: newGifts})
        }).catch(e => {
            console.log(e)
            console.log(e.response)
            if (!e.response.data) return;
            const json = e.response.data;
            if (json && !json.enoughPoints && json.remainPoints) {
                dispatch(setRemainPoints(json.remainPoints))
            }
        }).finally(() => {
            dispatch({ type: CONFIRM_POPUP_LOADING, payload: false })
        })
    }
}